import { Component, OnInit } from '@angular/core';
import {
    AgencyEnabledViews,
    AgencyOperatorEnabledViews
} from '../../../../models/frontend/enabled-views';
import { PataviumRole } from '../../../../models/request-and-responses/rest-api/enums/role.enum.model';
import {
    ISieveConf,
    ISieveFilterObject,
    ISieveSortsObject,
    SieveOperator,
    SieveString
} from '../../../../helpers/sieve/sieveString.class';
import { DataService } from '../../../../services/data.service';
import { SideMenu } from '../../../common/menu.model';
import { SieveFilter } from '../../../../helpers/sieve/sieve-filters-and-sorts';
import { SessionStorageService } from '../../../../services/session-storage.service';

@Component({
    selector: 'app-agency-sidebar',
    templateUrl: './sidebar.component.html',
    styleUrls: ['./sidebar.component.css']
})
export class AgencySidebarComponent implements OnInit {
    public _role: PataviumRole; //agenzia o operatore agenzia
    public Role = PataviumRole;
    public enabledViews;
    public sidemenu: SideMenu;
    //sieve
    public page: number = null;
    public pageSize: number = null;
    public filters: ISieveFilterObject[] = [];
    public sorts: ISieveSortsObject[] = [];
    get sieveConf(): ISieveConf {
        return {
            page: this.page,
            pageSize: this.pageSize,
            filters: this.filters,
            sorts: this.sorts
        };
    }

    constructor(private dataService: DataService) {
        this.sidemenu = new SideMenu();
    }

    ngOnInit() {
        this._role = SessionStorageService.sessionInfo.role; //TODO: separare in due componenti e pulire sessionstorage
        const sieveString = new SieveString(this.sieveConf);
        sieveString.addFilters([
            {
                key: SieveFilter.View.Role,
                operator: SieveOperator.Equal,
                value: this._role
            }
        ]);
        this.dataService.getViewPermissions(sieveString).subscribe(response => {
            if (this._role === PataviumRole.Agency) {
                this.enabledViews = new AgencyEnabledViews(response);
                console.log(this.enabledViews)
            } else if (this._role === PataviumRole.AgencyOperator) {
                this.enabledViews = new AgencyOperatorEnabledViews(response);
            }
        });
    }
}



// WEBPACK FOOTER //
// ./src/app/pages/role-specific/agency/sidebar/sidebar.component.ts